import FerryPickupList from '@/controllers/ferry_pickup/ferry-pickup-list.js';

export default {
  extends: FerryPickupList,
}
